import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const AssetSelect = ({
  onChange,
  options,
  optName,
  optVal,
  curVal,
  assetSel,
  fiatAssetSel,
  useId,
  disabled
}) => {
  const node = useRef();

  const [open, setOpen] = useState(false);

  const handleClickOutside = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const handleOnChange = (e) => {
    let useValue;
    if (e.target.getAttribute('data-value')) {
      useValue = e.target.getAttribute('data-value');
    }
    let useEvent;
    if (useId && useValue) {
      useEvent = {
        target: {
          id: useId,
          value: useValue,
        },
      };
      onChange(useEvent);
    }
  };

  let useOptions;
  let optionLoop;
  let current = {
    asset: '',
    name: 'Select An Asset',
    defaults: {},
  };
  if (fiatAssetSel) {
    current = {
      asset: '',
      name: 'Select Your Currency',
      defaults: {},
    }
  }
  let dropClass = 'drop-con';
  if (assetSel) {
    dropClass = 'drop-con dc-ass';
  }
  if (disabled) {
    dropClass = dropClass + ' dc-dis';
  }

  if (options && options.length) {
    if (optVal && curVal) {
      current = options.find((item) => item[optVal].toUpperCase() === curVal.toUpperCase());
    }
    if (current && optVal) {
      useOptions = options.filter((item) => item[optVal] !== current[optVal]);
      if (!current.asset) {
        useOptions = options;
      }
    }
    if (optName && optVal && current && useOptions) {
      optionLoop = useOptions && useOptions.map((item) => (
        <div
          key={item[optVal]}
          data-value={item[optVal]}
          className="dpo-i"
          onClick={handleOnChange}
        >
          {assetSel && (
            <div className={`card-coin ${item[optName].replace(/\s/g, "-").toLowerCase()}`}>
              <img alt={item[optName]} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${item[optName].replace(/\s/g, "-").toLowerCase()}.svg`} />
            </div>
          )}
          {item[optName].toLowerCase()}
        </div>
      ));
    }
  }

  return (
    <div
      ref={node}
      className={dropClass}
      onClick={
        disabled ? (
          null
        ) : (
          () => setOpen(!open)
        )
      }
    >
      <div className="drop-sel">
        { current && (
          <>
            {current[optVal] ? (
              <>
                {current[optName] && (
                  <>
                    {assetSel && (
                      <div className={`card-coin ${current[optName].replace(/\s/g, "-").toLowerCase()}`}>
                        <img alt={current[optName]} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${current[optName].replace(/\s/g, "-").toLowerCase()}.svg`} />
                      </div>
                    )}
                    {current[optName].toLowerCase()}
                  </>
                )}
              </>
            ) : (
              <>
                {current[optName].toLowerCase()}
              </>
            )}
          </>
        )}
      </div>
      {open && (
        <div className="drop-opts">
          {optionLoop}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

AssetSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  optName: PropTypes.string.isRequired,
  optVal: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  curVal: PropTypes.string.isRequired,
  assetSel: PropTypes.bool.isRequired,
  useId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(AssetSelect);
